import {
  getObject,
  getList,
  getInt32,
} from "@surya-digital/leo-ts-types";
import { GridOptionV1, GridOptionV1DTO } from "../types/gridOptionV1";
import { GridSingleSelectResultV1, GridSingleSelectResultV1DTO } from "./gridSingleSelectResultV1";
import { ProportionChartType } from "./proportionChartType";

export interface GridSingleSelectRowResultWithMeanV1DTO {
  gridOptionV1: GridOptionV1DTO;
  singleSelectResults: GridSingleSelectResultV1DTO[];
  proportionChartType: ProportionChartType.ProportionChartTypeDTO;
  totalResponses: number;
}

export class GridSingleSelectRowResultWithMeanV1 {
  readonly isGridSingleSelectRowResultWithMeanV1GridSingleSelectRowResultWithMeanV1: boolean = true;

  readonly gridOptionV1: GridOptionV1;
  readonly singleSelectResults: GridSingleSelectResultV1[];
  readonly proportionChartType: ProportionChartType.ProportionChartType;
  readonly totalResponses: number;

  static readonly constraints = {
    "singleSelectResults": {
      "maxSize": 32,
    },
  }

  constructor(
  gridOptionV1: GridOptionV1, 
  singleSelectResults: GridSingleSelectResultV1[], 
  proportionChartType: ProportionChartType.ProportionChartType, 
  totalResponses: number
  ) {
    this.gridOptionV1 = gridOptionV1;
    GridSingleSelectRowResultWithMeanV1.validateSingleSelectResults(singleSelectResults);
    this.singleSelectResults = singleSelectResults;
    this.proportionChartType = proportionChartType;
    this.totalResponses = totalResponses;
  }

  static fromDTO(dto: GridSingleSelectRowResultWithMeanV1DTO): GridSingleSelectRowResultWithMeanV1 {
    const gridOptionV1 = GridOptionV1.fromDTO(getObject(dto, "gridOptionV1", InvalidGridSingleSelectRowResultWithMeanV1GridOptionV1Error));
    const singleSelectResults = getList<GridSingleSelectResultV1DTO, GridSingleSelectResultV1>(
      dto,
      "singleSelectResults",
      GridSingleSelectResultV1.fromDTO,
      InvalidGridSingleSelectRowResultWithMeanV1SingleSelectResultsError
    );
    const proportionChartType = ProportionChartType.fromDTO(getObject(dto, "proportionChartType", InvalidGridSingleSelectRowResultWithMeanV1ProportionChartTypeError));
    const totalResponses = getInt32(dto, "totalResponses", InvalidGridSingleSelectRowResultWithMeanV1TotalResponsesError);
    return new GridSingleSelectRowResultWithMeanV1(
      gridOptionV1,
      singleSelectResults,
      proportionChartType,
      totalResponses
    );
  }

  toDTO(): GridSingleSelectRowResultWithMeanV1DTO {
    const dto: GridSingleSelectRowResultWithMeanV1DTO = {
        gridOptionV1: this.gridOptionV1.toDTO(),
        singleSelectResults: this.singleSelectResults.map((e: GridSingleSelectResultV1) => { return e.toDTO() }),
        proportionChartType: this.proportionChartType.toDTO(),
        totalResponses: this.totalResponses
    };
    return dto;
  }
  private static validateSingleSelectResults = (singleSelectResults: GridSingleSelectResultV1[]): void => {
    if(singleSelectResults.length > 32) {
      throw new InvalidGridSingleSelectRowResultWithMeanV1SingleSelectResultsMaxSizeError(
        32,
        `Attribute singleSelectResults is too long. Size is ${singleSelectResults.length}. Max size is 32.`
      );
    }
  }
  
}

GridSingleSelectRowResultWithMeanV1.prototype.toString = function toString(): string {
  return `GridSingleSelectRowResultWithMeanV1(gridOptionV1='${this.gridOptionV1}',singleSelectResults='${this.singleSelectResults}',proportionChartType='${this.proportionChartType}',totalResponses='${this.totalResponses}')`;
};

export class InvalidGridSingleSelectRowResultWithMeanV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleSelectRowResultWithMeanV1Error";
  }
}
export class InvalidGridSingleSelectRowResultWithMeanV1GridOptionV1Error extends InvalidGridSingleSelectRowResultWithMeanV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleSelectRowResultWithMeanV1GridOptionV1Error";
  }
}

export class InvalidGridSingleSelectRowResultWithMeanV1SingleSelectResultsError extends InvalidGridSingleSelectRowResultWithMeanV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleSelectRowResultWithMeanV1SingleSelectResultsError";
  }
}

export class InvalidGridSingleSelectRowResultWithMeanV1SingleSelectResultsMaxSizeError extends InvalidGridSingleSelectRowResultWithMeanV1SingleSelectResultsError {
  readonly maxSize: number;
  constructor(maxSize: number, message?: string) {
    super(message);
    this.maxSize = maxSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleSelectRowResultWithMeanV1SingleSelectResultsMaxSizeError";
  }
}

export class InvalidGridSingleSelectRowResultWithMeanV1ProportionChartTypeError extends InvalidGridSingleSelectRowResultWithMeanV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleSelectRowResultWithMeanV1ProportionChartTypeError";
  }
}

export class InvalidGridSingleSelectRowResultWithMeanV1TotalResponsesError extends InvalidGridSingleSelectRowResultWithMeanV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleSelectRowResultWithMeanV1TotalResponsesError";
  }
}
